import * as React from "react";

// Souvenir's component bundle reads React from window.React when it loads. This module must be
// evaluated before the bundle: souvenir.ts imports it first.
(window as unknown as { React: typeof React }).React = React;
